import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';

interface UnlockUserDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  loading?: boolean;
}

export const UnlockUserDialog = ({
  open,
  onClose,
  onConfirm,
  userName,
  loading = false,
}: UnlockUserDialogProps) => {
  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <LockOpenIcon sx={{ fontSize: 24, color: '#2e7d32' }} />
          <Typography variant="h6" fontFamily="GilroySemiBold">
            Unlock User Account
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Unlock account for <strong>{userName}</strong>? They will be able to login again.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={loading} sx={{ color: 'text.secondary' }}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{
            bgcolor: '#000',
            '&:hover': { bgcolor: '#333' },
            minWidth: 100,
          }}
        >
          {loading ? <CircularProgress size={20} /> : 'Unlock User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
